export type RegistrationSelectOption = {
  value: string;
  labelKey?: string;
  label?: string;
};

export const DRIVER_CABIN_TYPE_OPTIONS: RegistrationSelectOption[] = [
  { value: "N", labelKey: "REGISTRATION.DATA.DRIVER_CABIN_TYPE.NORMAL" },
  { value: "D", labelKey: "REGISTRATION.DATA.DRIVER_CABIN_TYPE.DOUBLE" },
];

export const SUSPENSION_TYPE_OPTIONS: RegistrationSelectOption[] = [
  { value: "AIR", labelKey: "REGISTRATION.DATA.SUSPENSION_TYPE.AIR" },
  { value: "LEAF", labelKey: "REGISTRATION.DATA.SUSPENSION_TYPE.LEAF" },
];

export const DH_TYPE_OPTIONS: RegistrationSelectOption[] = [
  { value: "1", labelKey: "REGISTRATION.DATA.DH_TYPE.NONE" },
  { value: "2", labelKey: "REGISTRATION.DATA.DH_TYPE.STANDARD" },
];
